module.exports = __webpack_public_path__ + "img/html-logo.11ed09ed.png";